import{erpplatfileserver} from '@/utils/baseUrl';
import{reportserver} from '@/utils/baseUrl';
import {post} from '@/utils/request';

//报表
export async function loadDataFromSvr(params) {
    return post(erpplatfileserver+'/reportForm/getFormJsonData', params, true);
}
//报表
export async function loadReportList(params) {
    return post(reportserver+"/report/getReportList", params, true);
}

//报表
export async function download(params) {
    return post(erpplatfileserver+'/reportForm/download', params, true);
}

/*async function  loadDataFromSvr(spread,param){

    var sheet = spread.getActiveSheet();
    var parm=rptJson.set.parm;
    //var a = {};
    for(var i = 0; i < parm.length; i++){
        a[parm[i].name]=$("input#inp_parm_"+parm[i].name)[0].value;
    }
    var json_data=param;
    /!*var json_data={
        "filename":rptFileName,
        "type":"data",
        "arg":a,
        "sn":spread.getActiveSheetIndex()
    };*!/
    $.ajax({
        type : "POST",
        url : "./jsoneditor/loaddata.jsp",
        data:{data:JSON.stringify(json_data)},
        async:true,
        cache:false,
        dataType:"json",
        beforeSend: function (xhr) {
            showLoading("#ss");
        },
        success : function(data){
            isview=true;
            window.setTimeout(function () {
                //hideLoading();
                try {
                    beforeLoadData(data,spread.getActiveSheetIndex());
                } catch (ex) {
                }
            }, 600);
        },
        error:function (res){
            console.log("erros:",res);
            hideLoading();

            showDialog("加载数据失败",res.responseJSON.data);
            //this.$message.error(res.message);
        }
    });
}*/

function loadRptInit(sn,data) {
    var ds ={};
    if (data.setdata.hasOwnProperty("sheet"+sn)) ds = data.setdata["sheet"+sn];
    try{

        $.each(rptJson.set.set, function (name, obj) {
            var p=obj.target;
            if (p ==sn && obj.hasOwnProperty("cols")){
                var sheet=spread.getSheet(p);
                CellValueChanged(sheet);
                CellDoubleClick(sheet);
                var cols=obj.cols;
                if (obj.type=="form")
                {
                    var index=0;
                    var dataRange=obj.range?obj.range:{row:0,col:0,rowcount:0,colcount:0,step:1,jump:1,bottom:0,offset:0};
                    var step=dataRange.step;
                    var start=dataRange.start?dataRange.start -1:dataRange.colcount -step ;

                    var jump=dataRange.jump>0?dataRange.jump:ds[obj.name].length;
                    if (obj.range)
                    {sheet.addColumns(dataRange.col + start+step, (jump -1)*step );

                    }
                    for (var j=1;j<jump  ;j++){
                        sheet.copyTo(dataRange.row ,dataRange.col +start  ,dataRange.row,dataRange.col +start +step*j, dataRange.rowcount, step , GC.Spread.Sheets.CopyToOptions.all);
                        for(var n=0;n<step;n++){sheet.setColumnWidth(dataRange.col+ start +step*j+n ,sheet.getColumnWidth(dataRange.col+start +n ));}

                    }
                    var pages=Math.ceil(ds[obj.name].length/jump);
                    for (var pg=0;pg<pages -1;pg++){
                        sheet.addRows(dataRange.row+dataRange.rowcount*(1+pg), dataRange.rowcount);
                        sheet.copyTo(dataRange.row ,dataRange.col ,dataRange.row+dataRange.rowcount*(1+pg) ,dataRange.col , dataRange.rowcount, dataRange.colcount+(jump -1)*step , GC.Spread.Sheets.CopyToOptions.all);
                        for (var i=0;i<dataRange.rowcount  ;i++)
                        {
                            var rowheight=sheet.getRowHeight(dataRange.row+i);
                            sheet.setRowHeight(dataRange.row+dataRange.rowcount*(1+pg)+i, rowheight,GC.Spread.Sheets.SheetArea.viewport);
                        }
                    }

                    var pagerow=0;
                    for (var page=0;page<pages ;page++){
                        for (var j=0;j<jump ;j++){
                            addrow=0;
                            for(var i = 0; i < cols.length; i++){
                                if(cols[i].hasOwnProperty("binding")){
                                    var binding=cols[i].binding;
                                    var cells = GC.Spread.Sheets.CalcEngine.formulaToRanges(sheet,binding);
                                    var cellRef =cells[0].ranges[0];
                                    var colname=cols[i].name;
                                    var tag=cols[i].hasOwnProperty("tag")?cols[i].tag:{};
                                    tag.cellobj={dsname:name,dstype:"form",colname:colname};
                                    sheet.getCell(cellRef.row+page*dataRange.rowcount+pagerow,cellRef.col).tag(JSON.stringify(tag));
                                    if (tag.hasOwnProperty("type") && tag.type=="dropdown")
                                    {
                                        var lock=sheet.getCell(cellRef.row+page*dataRange.rowcount+pagerow,cellRef.col).locked();
                                        if (tag.hasOwnProperty("img") && tag.img)
                                        {
                                            var CellStyle = sheet.getStyle(cellRef.row+page*dataRange.rowcount+pagerow+addrow,cellRef.col);
                                            CellStyle.cellButtons = [
                                                {
                                                    imageType: GC.Spread.Sheets.ButtonImageType.dropdown,
                                                    command: function(she,row,col,option){
                                                        she.endEdit();
                                                        she.startEdit();
                                                    },
                                                }
                                            ];
                                            sheet.setStyle(cellRef.row+page*dataRange.rowcount+pagerow+addrow,cellRef.col, CellStyle);
                                        }
                                        var cellType =  new DropDownCellType();
                                        sheet.setCellType(cellRef.row+page*dataRange.rowcount+pagerow,cellRef.col, cellType);
                                        sheet.getCell(cellRef.row+page*dataRange.rowcount+pagerow,cellRef.col).locked(lock);

                                    }
                                    if(cols[i].hasOwnProperty("sub"))
                                    { var sub=cols[i].sub;
                                        var subdata=ds[sub.data];
                                        var srow=sub.span=="row"?sub.group.length:1;
                                        for(var s = 0; s < subdata.length; s++){
                                            if (j==0 && s>0)
                                            {
                                                sheet.addRows(cellRef.row+page*dataRange.rowcount+pagerow+addrow+s*srow, srow);
                                                sheet.copyTo(cellRef.row+page*dataRange.rowcount+pagerow+addrow ,dataRange.col, cellRef.row+page*dataRange.rowcount+pagerow+addrow+s*srow, dataRange.col,srow, dataRange.colcount+(jump -1) *step  ,GC.Spread.Sheets.CopyToOptions.style|GC.Spread.Sheets.CopyToOptions.formula);
                                            }

                                            var v_text=sub.text.split(",");

                                            for(var v = 0; v < v_text.length &&j==0 ; v++){
                                                sheet.getCell(cellRef.row+page*dataRange.rowcount+pagerow+addrow+s*srow ,cellRef.col -(v_text.length+(sub.span=="row"?1:0) -v)   ).value(subdata[s][v_text[v]]);
                                            }

                                            for(var g = 0;sub.group && g < sub.group.length; g++){
                                                var gobj=sub.group[g];
                                                if (j==0  && gobj.text && sub.span=="row")sheet.getCell(cellRef.row+page*dataRange.rowcount+pagerow +addrow+s*srow +g,cellRef.col -1).value(gobj.text);
                                                sheet.getCell(cellRef.row+page*dataRange.rowcount+pagerow+addrow+s*srow+(sub.span=="row"?g:0),cellRef.col+step*j+(sub.span=="col"?g:0)).bindingPath(name+"_"+index+"."+subdata[s][sub.id]+"_"+gobj.item);
                                                if (gobj.formatter)	sheet.setFormatter(cellRef.row+page*dataRange.rowcount+pagerow+addrow+s*srow+(sub.span=="row"?g:0),cellRef.col+step*j+(sub.span=="col"?g:0),gobj.formatter);

                                            }

                                        }
                                        addrow+=srow*(subdata.length -1);

                                    }
                                    else
                                    {
                                        if (cols[i].onlyfirst)
                                        {if (j==0 )sheet.getCell(cellRef.row+page*dataRange.rowcount+pagerow+addrow,cellRef.col+step*j).bindingPath(name+"_"+index+"."+colname);
                                            if (j==0  && cols[i].formatter)	sheet.setFormatter(cellRef.row+page*dataRange.rowcount+pagerow+addrow,cellRef.col+step*j,cols[i].formatter);}
                                        else
                                        {sheet.getCell(cellRef.row+page*dataRange.rowcount+pagerow+addrow,cellRef.col+step*j).bindingPath(name+"_"+index+"."+colname);
                                            if (cols[i].formatter)	sheet.setFormatter(cellRef.row+page*dataRange.rowcount+pagerow+addrow,cellRef.col+step*j,cols[i].formatter);
                                        }
                                    }

                                }

                                ds[obj.name+"_"+index]=ds[obj.name][index];
                            }
                            if (dataRange.bottom>0 && j==(jump -1))
                            {
                                var offset=dataRange.offset?dataRange.offset:0;
                                sheet.addSpan(dataRange.row+dataRange.rowcount*(1+page)+pagerow +addrow -dataRange.bottom ,dataRange.col+dataRange.colcount+offset, dataRange.bottom, step*(j)+offset*(-1),GC.Spread.Sheets.SheetArea.viewport);


                            }

                            index++;
                            if (j==(jump -1))
                            {
                                pagerow+=addrow;
                            }


                        }
                    }
                }
                else if (obj.type=="set" && obj.binding )
                {
                    var binding=obj.binding;
                    var table = sheet.tables.findByName(binding);
                    if (table) table.autoGenerateColumns(false);
                    if (table) table.bindingPath(name);
                }


            }
        });
    } catch (error){
        spread.resumeCalcService(true);
        sheet.isPaintSuspended(false);
        sheet.resumePaint();
        // console.log("Error:" + error.message);
    }
}

function beforeLoadData(data,sn) {
    var listdata=data.listdata;
    var p=sn?sn:0;
    sheet = spread.getSheet(p);
    spread.suspendCalcService(true);
    sheet.isPaintSuspended(true);
    sheet.suspendPaint();
    //if (sheetjson.length==0) loadRptInit();
    if (sheetjson[p] !=undefined )
    {
        sheet.unbindAll();
        sheet.clear(-1, -1, -1, -1, GC.Spread.Sheets.SheetArea.viewport, 255);
        sheet.fromJSON(JSON.parse(sheetjson[p]));
    }
    else
    {
        sheetjson[p]=JSON.stringify(sheet.toJSON());
    }

    loadRptInit(p,data);
    var ds ={};
    if (data.setdata.hasOwnProperty("sheet"+p)) ds = data.setdata["sheet"+p];

    for(var i = 0; i < sheet.tables.all().length; i++){
        var table = sheet.tables.all()[i];
        var dataRange = table.dataRange();
        var setname=table.bindingPath();
        var newDataSource={};
        if (rptJson.set.set.hasOwnProperty(setname))
        {
            var cJson;
            cJson=rptJson.set.set[setname].cols;
            var hrows=cJson[0].headrows?cJson[0].headrows:1;
            var addcol=0;
            var celltag=0;
            for( var j=0;j<cJson.length;j++){
                // table.setColumnName(j+addcol,cJson[j].name);
                //var colname=table.getColumnName(j );
                var tag=cJson[j].tag?cJson[j].tag:{};

                if (cJson[j].hasOwnProperty("step"))
                {
                    var step=cJson[j].step;
                    var stepby=cJson[j].stepdata;
                    var total=cJson[j].hasOwnProperty("total")?1:0;
                    var stepdata=listdata[stepby];
                    var collist=new Array();
                    sheet.addColumns(dataRange.col+j+(step?step:1)+addcol, (stepdata.length -1 + total ) *step );
                    var CellWidth = new Array();
                    for(var n=0;n<step;n++)
                    {
                        if (cJson[j+n].formatter)
                        {
                            sheet.setFormatter(dataRange.row ,dataRange.col+j+n+addcol,cJson[j+n].formatter,GC.Spread.Sheets.SheetArea.viewport);
                            if (table.hasTotalsRow())sheet.setFormatter(dataRange.row+dataRange.rowCount ,dataRange.col+j+n+addcol,cJson[j+n].formatter,GC.Spread.Sheets.SheetArea.viewport);
                        }

                        CellWidth[n] =sheet.getColumnWidth(dataRange.col+j+n+addcol);
                    }


                    for(var m=0;m<stepdata.length ;m++)
                    {
                        var stepdata_m=stepdata[m].split("@");
                        if (m>0){
                            sheet.copyTo(dataRange.row -hrows,dataRange.col+j,dataRange.row -hrows ,dataRange.col+j+m*step+addcol, hrows+1, step , GC.Spread.Sheets.CopyToOptions.style|GC.Spread.Sheets.CopyToOptions.formula);
                            if (table.hasTotalsRow()) sheet.copyTo(dataRange.row +dataRange.rowCount,dataRange.col+j+addcol,dataRange.row +dataRange.rowCount ,dataRange.col+j+m*step+addcol, 1,step , GC.Spread.Sheets.CopyToOptions.style|GC.Spread.Sheets.CopyToOptions.formula);
                        }
                        for(var n=0;n<step;n++)
                        {

                            var newname=cJson[j+n].name+'_'+(j+n)+"_"+(m+1);
                            if (m==0)
                                collist[n]='[@'+newname+']';
                            else
                                collist[n]+=',[@'+newname+']';
                            table.setColumnName(j  +n+m*step+addcol ,newname);
                            newDataSource[newname]="";
                            var l_tag=tag;
                            //l_tag.colname=newname;
                            l_tag.cellobj={dsname:setname,dstype:"set",colname:stepdata_m[0]+"_"+(j+n)};

                            l_tag.stepdata=stepdata_m[0];
                            sheet.getCell(dataRange.row -1,dataRange.col+j+n+m*step+addcol).tag(JSON.stringify(l_tag));
                            sheet.getCell(dataRange.row -1,dataRange.col+j+n+m*step+addcol).value((step==1?stepdata_m[1]:cJson[j+n].title));


                            table.setColumnDataField(j  +n+m*step+addcol,stepdata_m[0]+"_"+(j+n));
                            table.setColumnFormula(j +n+m*step+addcol,"=SUM(["+newname+"])");
                            sheet.setColumnWidth(dataRange.col+j+n+m*step+addcol,CellWidth[n]);
                            if (cJson[j+n].backcolor !=undefined && stepdata_m[2] !=undefined)
                            {var bc=cJson[j+n].backcolor.split(";");
                                sheet.getCell(dataRange.row ,dataRange.col+j+n+m*step+addcol).backColor(bc[0].indexOf(stepdata_m[2]) !=-1?bc[1]:bc[2]?bc[2]:'#FFFFFF');
                            }
                        }

                        if (step>1){
                            sheet.addSpan(dataRange.row -hrows,dataRange.col+j+m*step+addcol,1,step,GC.Spread.Sheets.SheetArea.viewport);
                            sheet.getCell(dataRange.row -hrows,dataRange.col+j+m*step+addcol).value(stepdata_m[1]);
                        }


                    }

                    if (total>0)
                    {
                        //m=m -1;
                        sheet.copyTo(dataRange.row -hrows,dataRange.col+j,dataRange.row -hrows ,dataRange.col+j+m*step+addcol, hrows+1, step , GC.Spread.Sheets.CopyToOptions.style|GC.Spread.Sheets.CopyToOptions.formula);
                        if (table.hasTotalsRow()) sheet.copyTo(dataRange.row +dataRange.rowCount,dataRange.col+j+addcol,dataRange.row +dataRange.rowCount ,dataRange.col+j+m*step+addcol, 1, step , GC.Spread.Sheets.CopyToOptions.style|GC.Spread.Sheets.CopyToOptions.formula);
                        for(var n=0;n<step;n++)
                        {
                            var newname=cJson[j+n].name+'_'+(j+n);
                            table.setColumnName(j +n+m*step+addcol,newname);
                            table.setColumnDataField(j +n+m*step+addcol,"");
                            table.setColumnDataFormula(j+n+m*step+addcol,"=sum("+collist[n].toString()+")");

                            table.setColumnFormula(j +n+m*step+addcol,"=SUM(["+newname+"])");
                            sheet.getCell(dataRange.row -1,dataRange.col+j+n+m*step+addcol).value((step==1?"小计":cJson[j+n].title));
                            sheet.setColumnWidth(dataRange.col+j+n+m*step+addcol,CellWidth[n]);
                        }
                        if (step>1){
                            sheet.addSpan(dataRange.row -hrows,dataRange.col+j+m*step+addcol,1,step,GC.Spread.Sheets.SheetArea.viewport);
                            sheet.getCell(dataRange.row -hrows,dataRange.col+j+m*step+addcol).value("小计");
                        }

                    }

                    if (step==1)
                    {
                        sheet.addSpan(dataRange.row -hrows,dataRange.col+j+addcol,1,stepdata.length,GC.Spread.Sheets.SheetArea.viewport);
                        sheet.getCell(dataRange.row -hrows,dataRange.col+j+addcol).value(cJson[j].title);
                    }
                    j=j+step -1;
                    addcol+=(stepdata.length -1 + total ) *step ;
                }
                else
                {  var newname=cJson[j].name;
                    var title=(cJson[j].title)?(cJson[j].title):newname;
                    var visible=(cJson[j].hasOwnProperty("visible"))?(cJson[j].visible):true;
                    if (!visible){ addcol=addcol -1;}
                    else {
                        var l_tag=tag;
                        l_tag.cellobj={dsname:setname,dstype:"set",colname:newname};
                        sheet.getRange(dataRange.row -1, dataRange.col+j+addcol, 1, 1).tag(JSON.stringify(l_tag));
                        sheet.getCell(dataRange.row -hrows,dataRange.col+j+addcol).value(title);

                        if (cJson[j].type=='buttom')
                        {
                            style = new GC.Spread.Sheets.Style();
                            style.cellButtons = [
                                {
                                    caption: "新增",
                                    useButtonStyle: false,
                                    backColor: '#fff',
                                    command: function(sheet, row, col, option) {buttonClicked(sheet, row, col, option,"Insert");}
                                },
                                {
                                    caption: "删除",
                                    useButtonStyle: false,
                                    backColor: '#fff',
                                    command: function(sheet, row, col, option) {buttonClicked(sheet, row, col, option,"Delete");}
                                }

                            ];

                            sheet.setStyle(dataRange.row ,dataRange.col+j+addcol, style);
                        }
                        else
                        {
                            if (cJson[j].formatter)	sheet.getCell(dataRange.row,dataRange.col+j+addcol).formatter(cJson[j].formatter);
                            try{
                                if (cJson[j].merge) sheet.autoMerge(sheet.getRange(-1, dataRange.col+j+addcol, -1, 1), GC.Spread.Sheets.AutoMerge.AutoMergeDirection.none, GC.Spread.Sheets.AutoMerge.AutoMergeMode.restricted);
                                if (cJson[j].merge) sheet.autoMerge(sheet.getRange(-1, dataRange.col+j+addcol, -1, 1), GC.Spread.Sheets.AutoMerge.AutoMergeDirection.column, GC.Spread.Sheets.AutoMerge.AutoMergeMode.restricted);


                            } catch (error){
                                // console.log("Error:" + error.message);
                            }
                            table.setColumnName(j  +addcol,newname);
                            table.setColumnDataField(j +addcol,"");
                            if (cJson[j].data>-1) table.setColumnDataField(j +addcol,newname);
                        }
                    }
                    if (cJson[j].data>-1){
                        newDataSource[newname]="";
                    }


                }


            }
            newDataSource["_state"]=2;
        }
        var tds = ds[setname];
        if(tds==undefined|| tds.length==0) ds[setname].push(newDataSource);

    }
    var args={};
    var parm=rptJson.set.parm;
    for(var i = 0; i < parm.length; i++){
        args[parm[i].name]=$("input#inp_parm_"+parm[i].name)[0].value;
    }
    ds.parm=args;//data.setdata.parm  ;
    var dataSource1 = new spreadNS.Bindings.CellBindingSource(ds);
    sheet.setDataSource(dataSource1);
    for(var k = 0; k < sheet.tables.all().length; k++){
        var table = sheet.tables.all()[k];
        var range=table.dataRange();
        var rowheight=sheet.getRowHeight(range.row);
        var srow=1,trow=0;
        var bc="#FFFFFF";

        for (var i=0;i<range.rowCount  ;i++)
        {
            sheet.setRowHeight(i+range.row, rowheight,GC.Spread.Sheets.SheetArea.viewport);
            if (trow==srow || (i==range.rowCount -1 &&  range.rowCount>1))
            {
                if (i==1){bc=sheet.getRange(range.row+1, range.col, 1, range.colCount).backColor();}

                sheet.copyTo(range.row,range.col,range.row +i -trow+1,range.col, trow, range.colCount , GC.Spread.Sheets.CopyToOptions.style|GC.Spread.Sheets.CopyToOptions.formula);
                if (i==1){sheet.getRange(range.row+1, range.col, 1, range.colCount).backColor(bc);}
                srow=srow+trow;trow=0;
            }
            trow++;
        }

//         sheet.getRows(range.row, range.row+range.rowCount).locked(true);
    }

    spread.setActiveSheet(sheet.name());
    spread.resumeCalcService(true);
    sheet.isPaintSuspended(false);
    sheet.resumePaint();

    // }
}

function CellValueChanged(sheet){

    sheet.bind(GC.Spread.Sheets.Events.ValueChanged, function (sender, args) {
        var cellInfo=getCellInfo(sheet,args.row,args.col);
        var ds=sheet.getDataSource();
        var tag,data;
        if (cellInfo && cellInfo.type=="table")
        {
            var range=cellInfo.object.dataRange();
            tag=JSON.parse(sheet.getTag(range.row -1 ,args.col));
            data=ds.xf[tag.cellobj.dsname];
            var rows=data[args.row - range.row];
            var key=rows['_key'];
            if (rows['_state']*1==0)
            {
                if (rows[key]*1> 0) rows['_state']=1;
                if (rows[key]*1==0) rows['_state']=2;
            }

        }
        else
        {
            var s_tag=sheet.getTag(args.row,args.col);
            tag=JSON.parse(s_tag);
            if (tag.cellobj){
                data=ds.xf[tag.cellobj.dsname][0];
                if (data['_state']*1==0) data['_state']=1;
            }
        }
    })
}

function CellDoubleClick(sheet){
    sheet.bind(GC.Spread.Sheets.Events.CellDoubleClick, function (sender, args) {
        if(args.sheetArea === GC.Spread.Sheets.SheetArea.colHeader){
            // console.log("The column header was double clicked.");
        }
        if(args.sheetArea === GC.Spread.Sheets.SheetArea.rowHeader){
            // console.log("The row header was double clicked.");
        }
        if(args.sheetArea === GC.Spread.Sheets.SheetArea.corner){
            // console.log("The corner header was double clicked.");
        }
        var cellInfo=getCellInfo(sheet,args.row,args.col);
        var tag;
        if (cellInfo.type=="table")
        {
            var range=cellInfo.object.dataRange();
            var s_tag=sheet.getTag(range.row -1 ,args.col)
            tag=s_tag?JSON.parse(s_tag):{};
            var ds=sheet.getDataSource();
            var set=cellInfo.object.bindingPath();
            var data=ds.xf[set];
            var cdata=data[(args.row -range.row)];
            if (tag.hasOwnProperty("act"))
            {
                var act=tag.act;
                var args=(tag.arg).split(",");
                var arg={};
                for (var i=0;i<args.length ;i++){

                    var a=args[i];
                    if (a.indexOf('#')==0)
                    {
                        var cells = GC.Spread.Sheets.CalcEngine.formulaToRanges(sheet,a.substr(1));
                        var cellRef =cells[0].ranges[0];
                        arg[a]=sheet.getValue(cellRef.row,cellRef.col);
                    }
                    else if (a=='&cv')
                        arg[a]=cdata[tag.cellobj.colname];
                    else if (a=='&cs')
                        arg[a]=tag.stepdata;
                    else if (a=='&cd')
                        arg[a]=tag.data;
                    else
                        arg[a]=cdata[a];

                }
                loadActData(tag.sheet,arg);
            }


            if (tag.hasOwnProperty("type") && tag.type=="dropdown" && sheet.getCellType(args.row,args.col).typeName=="1")
            {
                sheet.endEdit();
                var lock= sheet.getCell(range.row  ,args.col).locked();
                var cellType =  new DropDownCellType();
                sheet.setCellType(args.row,args.col, cellType);
                sheet.getCell(args.row,args.col).locked(lock);
                sheet.startEdit();
            }


        }
        else
        {
            var s_tag=sheet.getTag(args.row,args.col);
            var  tag=s_tag?JSON.parse(s_tag):{};
            if (tag && tag.hasOwnProperty("act"))
            {
                var act=tag.act;
                var args=(tag.arg).split(",");
                var arg={};
                for (var i=0;i<args.length ;i++){

                    var a=args[i];
                    if (a.indexOf('#')==0)
                    {
                        var cells = GC.Spread.Sheets.CalcEngine.formulaToRanges(sheet,a.substr(1));
                        var cellRef =cells[0].ranges[0];
                        arg[a]=sheet.getValue(cellRef.row,cellRef.col);
                    }
                    else if (a=='&cd')
                        arg[a]=tag.data;
                    else if (a=='&cv')
                        arg[a]=sheet.getValue(args.row,args.col);


                }
                loadActData(tag.sheet,arg);
            }
            return;
        }
    });
}

function getCellInfo(sheet, row, column) {
    var result = {type: ""}, object;

    if ((object = sheet.comments.get(row, column))) {
        result.type = "comment";
    } else if ((object = sheet.tables.find(row, column))) {
        result.type = "table";
    }

    result.object = object;

    return result;
}

function loadActData(sheet,args){
    var parm=rptJson.set.parm;
    for(var i = 0; i < parm.length; i++){
        args[parm[i].name]=$("input#inp_parm_"+parm[i].name)[0].value;
    }
    var json_data={
        "filename":rptFileName,
        "type":"data",
        "arg":args,
        "sn":sheet
    };
    $.ajax({
        type : "POST",
        url : "./jsoneditor/loaddata.jsp",
        data:{data:JSON.stringify(json_data)},
        async:false,
        cache:false,
        dataType:"json",
        beforeSend: function (xhr) {
            showLoading("#ss");
        },
        success : function(data){

            //isview=true;
            window.setTimeout(function () {
                hideLoading();
                try {
                    beforeLoadData(data,sheet);
                } catch (ex) {
                }
            }, 600);
        },
        error:function (res){
            // console.log("erros:",res);
            hideLoading();
            showDialog("加载数据失败",res.responseJSON.data);

        }
    });
}

function showDialog(title,message) {

    var $messageContainer = $("#message-Container");
    $messageContainer.empty();
    var  $msgDiv = $( "<div >" +message+  "</div>  ");
    $msgDiv.appendTo($messageContainer);
    showModal(title, 300,$("#messagedialog").children(),function(){return;});
}

function showLoading(ob) {
    var $container = $(".gc-viewer"), width = $container.width(), height = $container.height();
    $("<span id='delaySpan'><span id='icon' class='ui-icon ui-icon-clock' style='display:inline-block'></span>正在加载数据...</span>")
        .addClass("loading")
        .css("left", width / 2 - 70)
        .css("top", height / 2 - 30)
        .insertAfter(ob);
    $("<div id='delayDiv'></div>")
        .css("background", "#2D5972")
        .css("opacity", 0.3)
        .css("position", "absolute")
        .css("top", 0)
        .css("left", 0)
        .css("width", width)
        .css("height", height)
        .insertAfter(ob);
}

function hideLoading() {
    $("#delayDiv").remove();
    $("#delaySpan").remove();
}

export default {
    loadDataFromSvr,
    loadReportList,
    beforeLoadData,
    loadRptInit,
    CellValueChanged,
    CellDoubleClick,
    getCellInfo,
    loadActData,
    showLoading,
    hideLoading,
    showDialog
}





